import AppBar from '@material-ui/core/AppBar'
import Grid from '@material-ui/core/Grid'
import React, { useState, useEffect } from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import { Route } from 'react-router-dom'
import ClientLogo from '../clientLogo'
import CompanyLogo from '../companyLogo'
import Menu from '../menu'
import {
  getComplianceMenu,
  getMinWageMenu,
  getPaidLeaveMenu,
  COMPLIANCE_USER_MENU,
  MINWAGE_USER_MENU,
  PAIDLEAVE_USER_MENU,
  SWITCH_COMPANY_OPTION,
  RESOURCES_MENU,
  PAID_LEAVE_RESOURCES_MENU
} from '../../constants'
import {
  CustomLink,
  DashboardAppBar,
  NavBar,
  CompanyLogoContainer,
  ToolbarLogoContainer,
  CustomSeparator,
  StyledPersonIcon,
  StyledMenuContainer,
  StyledName, StyledStageBanner
} from './styles'
import { ProdPerfectTracker } from '../../../vendor/prodPerfectTracker'
import { SESSION_STORAGE_KEYS } from '../../enums'
import useSessionStorage from '../../../hooks/useSessionStorage'
import useQuery from '../../../hooks/useQuery'

const MainToolbarRenderer = ({ authenticated, hasCompliance, hasMinimumWage, hasPaidLeave, hasLogo, hasMultipleCompanies, location, name }) => {
  const { getParam } = useQuery()
  const ignoreMaintenanceBannerKey = SESSION_STORAGE_KEYS.IGNORE_MAINTENANCE_BANNER
  const ignoreMaintenanceBannerParam = getParam(ignoreMaintenanceBannerKey)
  const complianceMenu = hasMultipleCompanies ? SWITCH_COMPANY_OPTION.concat(COMPLIANCE_USER_MENU) : COMPLIANCE_USER_MENU
  const minWageMenu = hasMultipleCompanies ? SWITCH_COMPANY_OPTION.concat(MINWAGE_USER_MENU) : MINWAGE_USER_MENU
  const paidLeaveMenu = hasMultipleCompanies ? SWITCH_COMPANY_OPTION.concat(PAIDLEAVE_USER_MENU) : PAIDLEAVE_USER_MENU
  const [ignoreMaintenanceBannerFlag, setIgnoreMaintenanceBannerFlag] = useState()
  const { getFromSessionStorage, setToSessionStorage } = useSessionStorage()

  const getIgnoreMaintenanceBanner = async () => {
    const sessionIgnoreMaintenanceBanner = JSON.parse(await getFromSessionStorage(ignoreMaintenanceBannerKey))
    if (ignoreMaintenanceBannerParam !== undefined && sessionIgnoreMaintenanceBanner !== JSON.parse(ignoreMaintenanceBannerParam)) {
      const newIgnoreMaintenanceBanner = JSON.parse(ignoreMaintenanceBannerParam)
      await setToSessionStorage(ignoreMaintenanceBannerKey, newIgnoreMaintenanceBanner)
      setIgnoreMaintenanceBannerFlag(newIgnoreMaintenanceBanner)
    } else {
      setIgnoreMaintenanceBannerFlag(sessionIgnoreMaintenanceBanner)
    }
  }

  useEffect(() => {
    getIgnoreMaintenanceBanner()
  }, [ignoreMaintenanceBannerParam])

  const isStage = API_BASE_PATH === 'https://elc-new-stage.govdocs.com/api'

  const StageBanner = () => (
    <StyledStageBanner>
      ***** STAGE *****
    </StyledStageBanner>
  )

  return (
    <React.Fragment>
      <AppBar
        data-testid="appbar"
        position="static"
        color="default"
        elevation={0}
        style={
          authenticated
            ? DashboardAppBar
            : { display: 'none' }
        }
      >
        {isStage ? <StageBanner /> : null}
        <NavBar style={{ padding: '5px' }}>
          <Toolbar
            style={{
              minHeight: 'unset',
              padding: 0
            }}
          >
            <Grid
              container
              justify="space-between"
              spacing={0}
              style={{ flexWrap: 'nowrap' }}
            >
              <Grid item>
                <ToolbarLogoContainer hasLogo={hasLogo}>
                  <Route
                    path="/compliance"
                    render={() => (
                      <a href="#/compliance">
                        {!hasLogo ? (<CompanyLogoContainer hasLogo={hasLogo}><CompanyLogo size="large" /></CompanyLogoContainer>) : (
                          <ClientLogo />)}
                      </a>
                    )}
                  />
                  <Route
                    path="/minWage"
                    render={() => (
                      <a href="#/minWage">
                        {!hasLogo ? (<CompanyLogoContainer hasLogo={hasLogo}><CompanyLogo size="large" /></CompanyLogoContainer>) : (
                          <ClientLogo />)}
                      </a>
                    )}
                  />
                  <Route
                    path="/paidLeave"
                    render={() => (
                      <a href="#/paidLeave">
                        {!hasLogo ? (<CompanyLogoContainer hasLogo={hasLogo}><CompanyLogo size="large" /></CompanyLogoContainer>) : (
                          <ClientLogo />)}
                      </a>
                    )}
                  />
                  {hasLogo ? (<CompanyLogoContainer hasLogo={hasLogo}><CompanyLogo /></CompanyLogoContainer>) : null}
                </ToolbarLogoContainer>
                <div
                  style={{
                    display: 'inline-block',
                    marginTop: '12px'
                  }}
                >
                  <Route
                    path="/compliance"
                    render={() => <Menu displayArrow text="Postings" items={getComplianceMenu(hasPaidLeave)} />}
                  />
                  <Route
                    path="/minWage"
                    render={() => <Menu displayArrow text="Minimum Wage" items={getMinWageMenu(hasPaidLeave)} />}
                  />
                  <Route
                    path="/paidLeave"
                    render={() => <Menu displayArrow text="Paid Leave" items={getPaidLeaveMenu()} />}
                  />
                </div>
              </Grid>

              <Grid item>
                {hasCompliance ? (
                  <Route
                    path="/compliance"
                    render={() => (
                      <React.Fragment>
                        <CustomLink
                          active={(location.pathname === '/compliance/locations').toString()}
                          to="/compliance/locations"
                        >Locations
                        </CustomLink>
                        <CustomLink
                          active={(location.pathname === '/compliance/shipments').toString()}
                          to="/compliance/shipments"
                        >Shipments
                        </CustomLink>
                        <CustomLink
                          active={(location.pathname === '/compliance/updates').toString()}
                          to="/compliance/updates"
                        >Updates
                        </CustomLink>
                        <CustomLink
                          active={(location.pathname === '/compliance/posters').toString()}
                          to="/compliance/posters"
                        >Posters
                        </CustomLink>
                        <CustomSeparator />
                        <Menu
                          displayArrow
                          text={menuText(name)}
                          items={complianceMenu}
                        />
                      </React.Fragment>
                    )}
                  />
                ) : null}

                {hasMinimumWage ? (
                  <Route
                    path="/minWage"
                    render={() => (
                      <React.Fragment>
                        <CustomLink
                          active={(location.pathname === '/minWage/locations').toString()}
                          to="/minWage/locations"
                        >Locations
                        </CustomLink>
                        <CustomLink
                          active={(location.pathname === '/minWage/notifications').toString()}
                          to="/minWage/notifications"
                        >Notifications
                        </CustomLink>
                        <Menu displayArrow={false} text="Resources" items={RESOURCES_MENU} />
                        <CustomSeparator />
                        <Menu
                          displayArrow
                          text={menuText(name)}
                          items={minWageMenu}
                        />
                      </React.Fragment>
                    )}
                  />
                ) : null}

                {hasPaidLeave ? (
                  <Route
                    path="/paidLeave"
                    render={() => (
                      <React.Fragment>
                        <CustomLink
                          active={(location.pathname === '/paidLeave/locations').toString()}
                          to="/paidLeave/locations"
                        >Locations
                        </CustomLink>
                        <CustomLink
                          active={(location.pathname === '/paidLeave/notifications').toString()}
                          to="/paidLeave/notifications"
                        >Notifications
                        </CustomLink>
                        <CustomLink
                          active={(location.pathname === '/paidLeave/summary').toString()}
                          to="/paidLeave/summary"
                        >Summary
                        </CustomLink>
                        <Menu displayArrow={false} text="Resources" items={PAID_LEAVE_RESOURCES_MENU} />
                        <CustomSeparator />
                        <Menu
                          displayArrow
                          text={menuText(name)}
                          items={paidLeaveMenu}
                        />
                      </React.Fragment>
                    )}
                  />
                ) : null}

              </Grid>
            </Grid>
          </Toolbar>
        </NavBar>
        <ProdPerfectTracker launchTracker />
      </AppBar>
    </React.Fragment>
  )
}

const menuText = (name) => {
  return (
    <StyledMenuContainer>
      <StyledPersonIcon />{' '}
      <StyledName>{name}</StyledName>
    </StyledMenuContainer>
  )
}

export default MainToolbarRenderer
